import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import PageLayout from '../PageLayout'
import appStore from '../../storage/AppStore'
import { useNavigate } from "react-router-dom";
import Btn from '../../ui/Btn'
import Select from '../../ui/Select'
import clubStore from '../../storage/ClubStore'
import systemStore from '../../storage/SystemStore'

const TrainingsList = ({ role, team }) => {
  const navigate = useNavigate();
  
  return (
    <div className="grid">
      {team.classes?.map((c, i) => (
        <div key={i} className="col-12 border-b">
          <div className="card shadow-1 p-3">
            <div className="flex justify-content-between align-items-center">
              
              {/* Left side */}
              <div>
                <div className="text-lg font-medium">
                  {appStore.tr[c.day]}
                </div>
                <div className="text-500 text-sm">
                  {c.date}
                </div>
              </div>
              
              <div className="text-center">
                <div className="text-xl font-semibold border-b">
                  {c.participated}
                </div>
                <div className="text-500 text-sm">
                  {c.total}
                </div>
              </div>
              {c.has_album && (
                <div className={"flex"}>
                  <Btn icon={'pi pi-verified'}
                       className={"mr-2"}
                       outlined
                       onClick={() => {
                         clubStore.trainer.sendClassPhotos(team.team_id, c.date, false).then(() => {
                           systemStore.setSuccess(appStore.tr.media_sent_to_telegram)
                         })
                       }}
                  />
                  <Btn icon={'pi pi-images'}
                       outlined
                       onClick={() => {
                         clubStore.trainer.sendClassPhotos(team.team_id, c.date, true).then(() => {
                           systemStore.setSuccess(appStore.tr.media_sent_to_telegram)
                         })
                       }}
                  />
                </div>
              )}
              {/* Action */}
              <Btn
                icon="pi pi-stopwatch"
                outlined
                onClick={() => navigate(`/trainer/class/${team.team_id}/${c.date}`)}
                tooltip={appStore.tr.attendance}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}


export default observer(TrainingsList)